var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'fill-height ' + (_vm.isDesktopView ? '' : 'pa-0')},[(_vm.isDesktopView)?_c('ObjectPageDesktop'):_c('ObjectPageMobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }